<template>
  <div class="tinymce-editor">
    <editor v-model="myValue" :init="init" :disabled="disabled"></editor>
  </div>
</template>

<script>
import tinymce from "tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.inline.min.css";
import "tinymce/themes/silver/theme";
import 'tinymce/icons/default/icons.min.js'
import "tinymce/plugins/paste";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount";
import 'tinymce/plugins/media'

import { uploadIllustration, uploadViewPaper,uploadIllustrationVideo } from "@/api/manage";
import config from "@/config/url.config";
export default {
  components: {
    Editor,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      default: "link lists image code table wordcounts media",
    },
    toolbar: {
      type: [String, Array],
      default:
        "bold italic underline strikethrough | fontsizeselect fontselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink code | removeformat",
    },
  },

  data() {
    // 可以直接获取到this的实例
    const self = this;
    return {
      success:'',
      failure:'',
      init: {
         language_url:process.env.NODE_ENV === 'production'
    ? "tinymce/langs/zh_CN.js"
    : "/tinymce/langs/zh_CN.js", //如果语言包不存在，指定一个语言包路径
       // language_url: "/tinymce/langs/zh_CN.js", //如果语言包不存在，指定一个语言包路径
        language: "zh_CN", //语言
        skin_url: process.env.NODE_ENV === 'production'
    ? "tinymce/skins/ui/oxide"
    : "/tinymce/skins/ui/oxide", //如果主题不存在，指定一个主题路径
        //skin_url: "/tinymce/skins/ui/oxide", //如果主题不存在，指定一个主题路径
        width: "1035px",
        height: "600px",
        plugins: this.plugins, //插件
        placeholder: "开始编写吧",
        toolbar: this.toolbar, //工具栏
        branding: false, //技术支持(Powered by Tiny || 由Tiny驱动)
        menubar: true, //菜单栏
        theme: "silver", //主题
        zIndex: 1101,
        placeholder: "hello",
        relative_urls: false,
        remove_script_host:false,
        images_upload_handler: async function (blobInfo, success, failure) {
         // console.log('this',this);
        // console.log('上传');
          console.log('上传图片11====')
           let formData = new FormData();
          formData.append("file", blobInfo.blob());
          //console.log('formData',formData.get('file'));
          let res = await uploadIllustration(formData);
          if (res.code == 200) {
            let url = config.baseURL + res.data.fileUrl + res.data.newName;
            success(url);
          } else {
            failure("上传失败！");
          }
        },
        file_picker_types: 'media',
	      file_picker_callback: function (cb, value, meta) {
          if(meta.filetype == 'media'){  
            let input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.onchange = async function(){
              const loading = self.$loading({
                lock: true,
                text: '上传中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              let file = this.files[0];//只选取第一个文件。如果要选取全部，后面注意做修改
              let formData = new FormData();
              //假设接口接收参数为file,值为选中的文件
              formData.append('file', file);
                let res = await uploadIllustrationVideo(formData);
                console.log('res',res);
                if (res.data.code == 200) {
                loading.close()
                let url = config.baseURL + res.data.data.fileUrl + res.data.data.newName;
                console.log('url',url);
                cb(url, { title: file.name });
                } else {
                loading.close()
                self.$message.error('上传失败')
                 }
            }
            //触发点击
            input.click();
          }
        }
      },
      myValue: this.value,
    };
  },
  created() {
    if(this.$route.name!=='newsAdd'&&this.$route.name!=='aboutUs'){
      this.init.width='1235px'
    }
    tinymce.init({});

    //console.log('tinymce',tinymce.success);
    // let a='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKYAAAA5CAYAAAC8uFDhAAAFVUlEQVR4Ae2cO4sUQRDH57OYi7GKRr4ODbyBFXwlB3qBoAhiIEbHYqCZBoKBkXupiYkGBga7yUXCwYEgh6dc4tsPUNKP6kfN9O7N3c7O9lYtLD1914/q//831T27sAXY18bGBl7uuzx05CRMeh85vgSbW5/2PUeTjn/+/oOTS5d0TO/ef2jSdSptL6/cnqjHhUsrjef6vP0Fmrw/bm7B8pVVF8uZi9dh+eoqHDtdur89f/mq0Zhqfvo6KEOfPm/Dyq378PPXbyhw8IMOqsY5ca7nFkoBVf+79/AR7HzbxSlbLW/eeVCJZe3x01bnpIPvBczzvfbBRIifPHsB127chaOnlrU2h4+e1fXXb942hrINMEP9pgpmOLBct6cAgtZ1SVc4jeSGYwqYqERGZddA4vxUMgGTKsKsjmB0XVLZBUyqCLN610Di/FR2AZMqwqyOYHRdUtkFTKoIs3rXQOL8VHYBkyrCrI5gdF1S2QVMqgiz+vaXr/v63HGaIKsY6EvApIowq3//8bNzMFUM9CVgUkUY1hUYXWRONWcdlMoCAZMhiDksWcDMwSWGMbYGphpY3qLBPDAg35UzzGw5LFnAzMElhjEKmAxNz2HJAmYOLjGMUcBkaHoOSxYwc3CJYYwCJkPTc1iygJmDSwxjFDAZmp7DkgXMHFxiGKOAydD0HJYsYObgEsMYBUyGpuewZAEzB5cYxihgMjQ9hyULmDm4xDBGAZOh6TksWcDMwSWGMQqYDE3PYckCZg4uMYyxezB3BlAWBZTrs/ml4W493oVBr4CiN4BJqx2uFVAUfRh2G3BnszcGc3e9hKIoYbAzpZhbA3MI/daAt4A1BkfA3Cs1iwtma8ADwKgPRaEyWtNML2AKmC2CabbZEso9bsveDAHTazH+agoZMxA7yCQqm/RH1cmNqSbb6DNUBSCzBRdr5HRl28Vj2rY2e2GfeI44s7mzm4u1D0N7HY+tYq+LJTgi6H5jjjVuDhNDfxRoFUpj1xZmYRdn2I7R9fTAVHAEMBlhQ9OsKdG5zIPlH37qYACACpgBIGjYaODPvhXgTSMHbfQAkpizBrz4jJ3oBwCmXXxz1s5t4fXr933l4afBL3XFxiiz64DzIDnBrQGVrFQxJmE2BTM1HkI6FszwhgmBjZ+CNUgRwHatwQ1o9Ij71WdaNY9dmxszkUFTmuLaGJTTy5hObFTNmIBgmmxBDawBGM0LzNcjUjBtPZlVxoKZjsPfOCZ+X8dYCdQ0LhVs8qYhICZiVEMk9UJ5F7xsHUzc3qvZxypbMWePGVN1twCYs1k9MHhjoI9pw0k21GPHAOP2jGfBqAxvTN2XxKMDqAczgt8Gmo4TV7LY5WzBjM6XVtiDgIne2DEUKM7kyrim8TjDw21Zt4uydrwD4NS6pCDaG8bF4hrXg0lvHtV8XJxuuAW+mBmY1bOpURWzkDeHZC4UP2k2NiDg7ANM/4BVs41T+HBaXZIsn5gbx/ff/JB+bkz797ob2bVZ7IuZgekO/qHYQabzYPqnUp9x0KggI476Pjsqj+xYlT5R1puciVSmKntl5WtDncHC7ZpwQTOcqQfxugea+CvJ6o2JMaqPmOKjBJlyoaszBFPp6AHT5zNldCK7oLHmHNeHYQW80ED8nJB4ZbOsGgPBpwCRHu7ciu31/xMxRn1rMnq8BnXmJFu5HQDhNGs1ME+MM5p88SqNwVw8CciKxm7ZpK1UW1NAwCTS6kxFtn/SRKozUEDADEWWbBmq0em1gKnkt2dIdcbzD0+d+sJ+cgGTPQLzKYCAOZ++sI9KwGSPwHwKIGDOpy/soxIw2SMwnwL8BxVxAPoYfqRTAAAAAElFTkSuQmCC'
    // function dataURLtoFile(dataurl, filename) {//将base64转换为文件
    //     var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
    //         bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    //     while(n--){
    //         u8arr[n] = bstr.charCodeAt(n);
    //     }
    //     return new File([u8arr], filename, {type:mime});
    // }
    //  let formData = new FormData();
    //       formData.append("file", dataURLtoFile(a,'img'));
     //      this.init.images_upload_handler()
  },
  mounted() {
    
  },
  methods: {
    calcWidth() {
      return document.body.clientWidth - 280 + "px";
    },
    obtainTxt() {
      // console.log(this.myValue)
    },
  },
  watch: {
    value(newValue) {
      this.myValue = newValue;
    },
    myValue(newValue) {
      this.$emit("input", newValue);
     // console.log('newValue',newValue);
    },
  },
};
</script>